import React from 'react';
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Error from "widgets/alerts/Error";
import Success from "widgets/alerts/Success";
import ToastContainer from "services/ToastContainer";
import {OperationsContext} from "@morningtrain/react-resources";

export default class Toastify extends React.Component {

    static contextType = OperationsContext;

    componentDidMount() {
        if(!this.context) {
            return;
        }

        this.context.onCreate(this.addCallbacks.bind(this));
    }

    addCallbacks(operation) {
        operation.onExecute(this.onSuccess.bind(this));
        operation.onError(this.onError.bind(this));
    }

    onSuccess(data) {
        if (data.message) {
            toast.success(<Success message={data.message}/>, {
                containerId: 'successContainer',
            });
        }
    }

    onError(error) {
        if (typeof (error.response) !== 'undefined') {

            if (error.response.status === 404 || error.response.status === 401) {
                /// Suppress 404 error - they should be caught and display a 404 page
                return;
            }

            const data = error.response.data;

            let message = null;

            if (data.errors) {
                message = (
                    <React.Fragment>
                        Du har ikke udfyldt alle felter korrekt - Tjek formularen for flere detaljer.
                    </React.Fragment>
                );
            } else if (data.message) {
                message = data.message;
            } else if (data.error) {
                message = data.error;
            } else {
                message = 'Der skete en ukendt serverfejl.';
            }

            if(message !== null) {
                toast.error(<Error message={message}/>, {
                    containerId: 'errorContainer',
                });
            }

        }
    }

    render() {
        return (
            <React.Fragment>
                <ToastContainer
                    className={'w-auto max-w-md'}
                    toastClassName={'rounded-md bg-green-100 p-4'}
                    progressClassName={'bg-green-300'}
                    containerId={'successContainer'}
                />
                <ToastContainer
                    className={'w-auto max-w-md'}
                    toastClassName={'rounded-md bg-red-100 p-4'}
                    progressClassName={'bg-red-300'}
                    containerId={'errorContainer'}
                />
                {this.props.children}
            </React.Fragment>
        );
    }

}
